import script from "./PortalAnalyticsBarCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalAnalyticsBarCard.vue?vue&type=script&setup=true&lang=js"

import "./PortalAnalyticsBarCard.vue?vue&type=style&index=0&id=428173c0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428173c0"]])

export default __exports__